import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_SUPPLIERS = "fetchSuppliers";
export const FETCH_SUPPLIER = "fetchSupplier";
export const SAVE_SUPPLIER = "saveSupplier";
export const UPDATE_SUPPLIER = "updateSupplier";
export const DELETE_SUPPLIER = "deleteSupplier";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingSupplier";
export const SET_SUPPLIERS = "setSuppliers";

const state = {
  errors: [],
  suppliers: [],
  isLoadingSupplier: false
};

const getters = {
  isLoadingSupplier() {
    return state.isLoadingSupplier;
  },
  getSuppliers() {
    return state.suppliers;
  }
};

const actions = {
  [FETCH_SUPPLIERS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("suppliers" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_SUPPLIER](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("suppliers", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_SUPPLIER](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("suppliers", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_SUPPLIER](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("suppliers", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_SUPPLIER](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("suppliers", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingSupplier = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingSupplier = value;
  },
  [SET_SUPPLIERS](state, data) {
    state.isLoadingSupplier = false;
    state.suppliers = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
